import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AttachmentModal from 'components/attachments/attachment_modal';
import AttachmentPreviewOpener from 'components/lib/attachment/attachment_preview_opener';
import AttachmentStatus from 'models/attachment/attachment_status';
import CustomChannelMessageAttachment from 'models/custom_channel_message_attachment';
import GenericAttachment from 'components/lib/attachment/generic_attachment';
import { getCustomChannelAttachmentUrl } from 'scripts/domain/services/attachments';
import { HandleHeightChange } from 'components/customer/conversation_history/virtualized/list_item';
import InlineImageAttachment from 'components/lib/attachment/inline_image_attachment';

const CustomChannelMessageAttachmentsContainer = AttachmentPreviewOpener(CustomChannelMessageAttachments);

function CustomChannelMessageAttachments({ attachments, itemId, orgId }) {
  const [previewAttachment, setPreviewAttachment] = useState(null);
  if (_.isEmpty(attachments)) {
    return null;
  }

  const [inlineImageAttachments, genericAttachments] = _.partition(
    attachments,
    a => !a.isRedacted && a.isImage() && a.status === AttachmentStatus.AVAILABLE
  );
  const availableAttachments = _.filter(attachments, a => a.status === AttachmentStatus.AVAILABLE);

  return (
    <React.Fragment>
      <div className="itemAttachments">
        <ul className="inlineImageAttachments">{_.map(inlineImageAttachments, renderInlineImageAttachment)}</ul>
        <ul className="genericAttachments">{_.map(genericAttachments, renderGenericAttachment)}</ul>
      </div>

      {previewAttachment && (
        <AttachmentModal
          attachment={previewAttachment}
          attachments={availableAttachments}
          setAttachment={setPreviewAttachment}
          url={getDownloadUrl(previewAttachment)}
        />
      )}
    </React.Fragment>
  );

  function renderGenericAttachment(attachment, index) {
    return (
      <GenericAttachment
        attachment={attachment}
        key={attachment.id}
        onClick={(attachment.status === AttachmentStatus.AVAILABLE && openAttachmentPreview) || undefined}
      />
    );

    function openAttachmentPreview() {
      setPreviewAttachment(attachment);
    }
  }

  function renderInlineImageAttachment(attachment, index) {
    return (
      <HandleHeightChange key={attachment.id}>
        {({ onHeightChange }) => (
          <InlineImageAttachment
            attachment={attachment}
            inlinePreviewImageUrl={getPreviewUrl()}
            key={attachment.id}
            onClick={openAttachmentPreview}
            onLoad={onHeightChange}
          />
        )}
      </HandleHeightChange>
    );

    function getPreviewUrl() {
      let imageUrl = getDownloadUrl(attachment);
      return `${imageUrl}?size=preview`;
    }

    function openAttachmentPreview() {
      setPreviewAttachment(attachment);
    }
  }

  function getDownloadUrl(a) {
    return getCustomChannelAttachmentUrl(orgId, a);
  }
}

CustomChannelMessageAttachmentsContainer.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.instanceOf(CustomChannelMessageAttachment)).isRequired,
  customChannelId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  onHeightChange: PropTypes.func,
};

CustomChannelMessageAttachments.propTypes = {
  ...AttachmentPreviewOpener.childPropTypes,
  ...CustomChannelMessageAttachmentsContainer.propTypes,
};

export { CustomChannelMessageAttachments };
export default CustomChannelMessageAttachmentsContainer;
